<template>
    <a-modal
      :visible="moveToData ? true : false"
      title="Move Meals Restriction"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <a-row>
        <a-col :xs="24" :lg="24">
          <!-- 餐食 -->
          <a-form-item>
            <span slot="label">Move <strong>{{ moveToData ? moveToData.enName : '' }}</strong> after</span>
            <a-select
              v-model="moveToCurrentId"
              style="width: 100%;"
              :showSearch="true"
              optionFilterProp="children"
              v-decorator="[
                'MealRequest',
                { rules: [{ required: true, message: 'Please select Meals Restriction!' }] },
              ]"
            >
              <a-select-option :value="'top'">Top</a-select-option>
              <a-select-option v-for="i in mealsList" :key="'meals-' + i.id" :value="i.id">{{ i.enName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <template slot="footer">
          <a-button type="primary" @click="handleOk" :loading="saving">
            Confirm
          </a-button>
      </template>
    </a-modal>
</template>

<script>
import MealrequestApi from '@/api/dict/api-mealrequest'

export default {
  name: 'MealsMove',
  components: {
  },
   props: {
    initData: {
      type: [Object],
      default: null
    }
  },
  data () {
    return {
      mealsList: [],
      moveToData: null,
      moveToCurrentId: null,
      saving: false,
    }
  },
  created () {
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.saving = false
      this.moveToCurrentId = 'top'
      this.moveToData = this.initData
      const resMeals = await MealrequestApi.list()
      const mealsList = resMeals.data
      this.mealsList = mealsList

    },
    async handleOk () {
      this.saving = false
      if (this.moveToCurrentId === 'top') {
        await MealrequestApi.moveTo(this.moveToData.id)
      } else {
        await MealrequestApi.moveTo(this.moveToData.id, this.moveToCurrentId)
      }
      this.saving = true
      this.$emit('ok')
    },
    handleCancel () {
      this.$emit('cancel')
    }
  },
  watch: {
    initData () {
      this.loadData()
    }
  }
}
</script>
